module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/icons/empty-states/no-addresses-816afe2ed574bcb182bac0286b65bef1.svg";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/icons/empty-states/no-addresses.svg
// module id = X07A
// module chunks = 21 23